import { render } from "./Verification.vue?vue&type=template&id=4999a0c5&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"

import "./Verification.vue?vue&type=style&index=0&id=4999a0c5&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4999a0c5"]])

export default __exports__